<template>
  <div class="tabbar">
    <van-tabbar v-model="active" :placeholder="true" safe-area-inset-bottom route active-color="#FEB013" inactive-color="#C9C9C9">
      <van-tabbar-item replace to="/work/index">
        <span>早班</span>
        <template #icon="props">
          <img :src="props.active ? amIcon.active : amIcon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/index" icon="guide-o">
        <span>晚班</span>
        <template #icon="props">
          <img :src="props.active ? pmIcon.active : pmIcon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/home">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? meIcon.active : meIcon.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

export default {
  name: 'Tabbar',
  data() {
    return {
      active: 1,
      amIcon: {
        active: require('@/assets/tabbar/am_active.svg'),
        inactive: require('@/assets/tabbar/am_inactive.svg')
      },
      pmIcon: {
        active: require('@/assets/tabbar/pm_active.svg'),
        inactive: require('@/assets/tabbar/pm_inactive.svg')
      },
      meIcon: {
        active: require('@/assets/tabbar/me_active.svg'),
        inactive: require('@/assets/tabbar/me_inactive.svg')
      }
    }
  }
}
</script>

<style>

</style>
